import { Container, Box, IconButton, Typography, Card } from '@mui/material';
import Grid from 'components/core/Grid';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import styled, { css } from 'styled-components';

const StyledBox = styled(Box)`
  margin-top: ${props => props.theme.spacing(2)};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ContentBox = styled(Box)`
  padding-top: ${props => props.theme.spacing(1)};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledCard = styled(Card)<{ $hasShadow: boolean }>`
  ${props =>
    !props.$hasShadow &&
    css`
      box-shadow: none !important;
    `}
`;

const StyledIconButton = styled(IconButton)`
  margin-left: ${props => props.theme.spacing(1)};
  margin-right: ${props => props.theme.spacing(1)};
`;

export interface FullPageCardStep {
  step: number;
  title: string;
  hasBack: boolean;
  hasShadow?: boolean;
}

interface Props {
  children: React.ReactNode;
  step: FullPageCardStep;
  goBack?: () => void;
  hasShadow?: boolean;
}

export const FullPageCard = ({ step, children, goBack = () => null, hasShadow = false }: Props) => {
  return (
    <Container maxWidth={'xs'}>
      <StyledBox>
        <StyledCard $hasShadow={hasShadow}>
          <Grid container>
            <Grid item xs={12}>
              <ContentBox>
                {step?.hasBack ? (
                  <StyledIconButton onClick={goBack}>
                    <ArrowBackIcon />
                  </StyledIconButton>
                ) : (
                  <Box width="40px"></Box>
                )}
                <Typography variant="h5">{step?.title}</Typography>
                <Box width="40px"></Box>
              </ContentBox>
            </Grid>
            <Grid item xs={12}>
              {children}
            </Grid>
          </Grid>
        </StyledCard>
      </StyledBox>
    </Container>
  );
};
